module.exports = __webpack_public_path__ + "img/scb.26235006.png";